import React from 'react'

function SvgAvis() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
<path d="M9.57924 2.76159C9.75138 2.4128 10.2487 2.4128 10.4209 2.76159L12.6492 7.27669C12.7176 7.4152 12.8497 7.5112 13.0026 7.53341L17.9853 8.25744C18.3702 8.31337 18.5239 8.78639 18.2453 9.05788L14.6398 12.5724C14.5292 12.6802 14.4787 12.8355 14.5049 12.9878L15.356 17.9504C15.4218 18.3337 15.0194 18.626 14.6751 18.4451L10.2184 16.102C10.0817 16.0302 9.9184 16.0302 9.78169 16.102L5.32501 18.4451C4.98074 18.626 4.57837 18.3337 4.64412 17.9504L5.49526 12.9878C5.52137 12.8355 5.4709 12.6802 5.3603 12.5724L1.75478 9.05788C1.47625 8.78639 1.62995 8.31337 2.01486 8.25744L6.99757 7.53341C7.15042 7.5112 7.28255 7.4152 7.35091 7.27669L9.57924 2.76159Z" stroke="currentColor" stroke-width="1.66667" stroke-linejoin="round"/>
</svg>
  )
}

export default SvgAvis